// SCO-3178: the get-tournaments row fields RAT 2027's Share flyers read (date, venue, fee, pre-reg), forwarded
// hero → event menu URL → Share child URL (the sheet's pages only know what their URL carries).
export const SHARE_ROW_KEYS = [
  "gametime",
  "timezone",
  "locationname",
  "locationcity",
  "locationstate",
  "locationfullname",
  "locationimage",
  "gameprepaytype",
  "gameticketprice",
  "gameprereg",
];

// `&key=value` for each present field; `get(key)` reads the row or the page's URL.
export const shareRowQuery = (get) =>
  SHARE_ROW_KEYS.map((k) => [k, get(k)])
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `&${k}=${encodeURIComponent(v)}`)
    .join("");
